import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
	ChatSocketChannel,
	defaultChatChannels,
	TWsParamsMessage,
	TWsParamsWriting,
} from 'Pages/chat'

interface State {
	channels: Set<ChatSocketChannel>
	prevPing: number
	currentPing: number
	hasWorker: boolean
	subscription: boolean
}

const initialState: State = {
	channels: new Set(defaultChatChannels),
	prevPing: 0,
	currentPing: 0,
	hasWorker: false,
	subscription: false,
}

export namespace ChatSocketNS {
	export type Channels = PayloadAction<ChatSocketChannel[]>
	export type SetChannels = PayloadAction<Set<ChatSocketChannel>>
	export type SetPrevPing = PayloadAction<number>
	export type SetCurrentPing = PayloadAction<number>
	export type SetHasWorker = PayloadAction<boolean>
	export type CloseConnection = PayloadAction<{ isNeedClearChannels?: boolean }>
	export type SetSubscription = PayloadAction<boolean>
	export type SendMessage = PayloadAction<TWsParamsMessage | TWsParamsWriting>
}

export const chatSocketSlice = createSlice({
	name: 'chatSocket',
	initialState,
	reducers: {
		subscribeChannels: (state, action: ChatSocketNS.Channels) => {},
		unSubscribeChannels: (state, action: ChatSocketNS.Channels) => {},
		setChannels: (state, action: ChatSocketNS.SetChannels) => {
			state.channels = new Set(action.payload)
		},
		setPrevPing: (state, action: ChatSocketNS.SetPrevPing) => {
			state.prevPing = action.payload
		},
		setCurrentPing: (state, action: ChatSocketNS.SetCurrentPing) => {
			state.currentPing = action.payload
		},
		setHasWorker: (state, action: ChatSocketNS.SetHasWorker) => {
			state.hasWorker = action.payload
		},
		closeConnection: (state, action: ChatSocketNS.CloseConnection) => {},
		setSubscription: (state, action: ChatSocketNS.SetSubscription) => {
			state.subscription = action.payload
		},
		sendMessage: (state, action: ChatSocketNS.SendMessage) => {},
		sendPingMessage: (state) => {},
	},
})
